export const authRoles = {
  sa: ['masteradmin', 'superadmin'],
  admin: ['masteradmin', 'superadmin', 'admin', 'employee', 'asstadmin'],
  editor: ['masteradmin', 'superadmin', 'admin', 'EDITOR'],
  guest: ['masteradmin', 'superadmin', 'admin', 'EDITOR', 'GUEST'],
};
